import { useEffect } from "react";
import { X } from "lucide-react";
import { useAuthModal } from "./AuthModalContext";
import Login from "./views/Login";
import Signup from "./views/signup";
import "./AuthModal.css";

// Global login/signup popup. Rendered once at the app root; visibility and
// mode are driven by AuthModalContext.
function AuthModal() {
  const { open, mode, closeAuth, setMode } = useAuthModal();

  // Close on Escape; lock body scroll while open.
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") closeAuth();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, closeAuth]);

  if (!open) return null;

  return (
    <div className="auth-modal-overlay" onClick={closeAuth}>
      <div className="auth-modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="auth-modal-close" onClick={closeAuth} aria-label="Close">
          <X size={20} />
        </button>

        {mode === "signup" ? (
          <Signup asModal onClose={closeAuth} onSwitch={() => setMode("login")} />
        ) : (
          <Login asModal onClose={closeAuth} onSwitch={() => setMode("signup")} />
        )}
      </div>
    </div>
  );
}

export default AuthModal;
